import { useState } from "react";

export default function Contact() {
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const data = new URLSearchParams(new FormData(form) as unknown as Record<string, string>);
    setLoading(true);
    try {
      await fetch("https://readdy.ai/api/form/d6usmb67ipaugi04le70", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: data.toString(),
      });
      setSubmitted(true);
    } catch {
      // handle error silently
    } finally {
      setLoading(false);
    }
  };

  return (
    <section id="contacto" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-16">
          <p className="text-teal-600 text-xs font-bold tracking-[0.3em] uppercase mb-3">Estamos aquí para ti</p>
          <h2 className="text-4xl font-black text-gray-900 tracking-widest">CONTACTO</h2>
          <div className="w-12 h-1 bg-teal-500 mx-auto mt-4 rounded-full" />
        </div>

        <div className="grid md:grid-cols-2 gap-12 items-start">
          {/* Info */}
          <div className="space-y-8">
            <div>
              <h3 className="text-gray-800 font-black text-lg mb-6">Información de Contacto</h3>
              <div className="space-y-5">
                {[
                  {
                    icon: "ri-map-pin-fill",
                    label: "Dirección",
                    text: "Av. Tiradentes, Plaza Alva, local A, Santo Domingo, República Dominicana",
                  },
                  { icon: "ri-phone-fill", label: "Teléfono", text: "+1 809-973-2576" },
                  { icon: "ri-mail-fill", label: "Email", text: "info@insercom.com" },
                  { icon: "ri-time-fill", label: "Horario", text: "Lunes – Viernes: 8:00am – 5:00pm" },
                ].map((item) => (
                  <div key={item.label} className="flex gap-4 items-start">
                    <div className="w-10 h-10 bg-teal-100 rounded-full flex items-center justify-center flex-shrink-0">
                      <i className={`${item.icon} text-teal-600 text-base`} />
                    </div>
                    <div>
                      <p className="text-xs font-bold text-teal-600 uppercase tracking-wide">{item.label}</p>
                      <p className="text-gray-600 text-sm mt-0.5">{item.text}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Social */}
            <div>
              <p className="text-xs font-bold text-gray-500 uppercase tracking-wide mb-3">Redes Sociales</p>
              <div className="flex gap-3">
                {[
                  { icon: "ri-instagram-fill", href: "#", label: "Instagram" },
                  { icon: "ri-whatsapp-fill", href: "#", label: "WhatsApp" },
                  { icon: "ri-facebook-fill", href: "#", label: "Facebook" },
                ].map((s) => (
                  <a
                    key={s.label}
                    href={s.href}
                    className="w-10 h-10 bg-teal-600 hover:bg-teal-500 text-white rounded-full flex items-center justify-center transition-colors cursor-pointer"
                    aria-label={s.label}
                  >
                    <i className={`${s.icon} text-base`} />
                  </a>
                ))}
              </div>
            </div>

            {/* Map */}
            <div className="rounded-xl overflow-hidden h-52">
              <iframe
                title="Ubicación INSERCOM"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3784.765!2d-69.936!3d18.473!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8eaf89f2a5a2b3a1%3A0x1!2sAv.+Tiradentes%2C+Santo+Domingo!5e0!3m2!1ses!2sdo!4v1680000000000"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>
          </div>

          {/* Form */}
          <div className="bg-white rounded-2xl p-8">
            <h3 className="text-gray-800 font-black text-lg mb-6">Solicitar Cotización</h3>
            {submitted ? (
              <div className="flex flex-col items-center justify-center py-12 text-center gap-4">
                <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center">
                  <i className="ri-check-double-fill text-teal-600 text-3xl" />
                </div>
                <p className="text-gray-800 font-bold text-lg">¡Mensaje enviado!</p>
                <p className="text-gray-500 text-sm">Nos pondremos en contacto contigo pronto.</p>
                <button
                  onClick={() => setSubmitted(false)}
                  className="mt-2 text-teal-600 text-sm font-semibold underline cursor-pointer"
                >
                  Enviar otro mensaje
                </button>
              </div>
            ) : (
              <form
                data-readdy-form
                id="insercom-cotizar-form"
                onSubmit={handleSubmit}
                className="space-y-4"
              >
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <label className="text-xs font-bold text-gray-500 uppercase tracking-wide mb-1 block">
                      Nombre *
                    </label>
                    <input
                      name="nombre"
                      required
                      type="text"
                      placeholder="Tu nombre"
                      className="w-full border border-gray-200 rounded-lg px-4 py-2.5 text-sm text-gray-700 focus:outline-none focus:border-teal-400"
                    />
                  </div>
                  <div>
                    <label className="text-xs font-bold text-gray-500 uppercase tracking-wide mb-1 block">
                      Apellido *
                    </label>
                    <input
                      name="apellido"
                      required
                      type="text"
                      placeholder="Tu apellido"
                      className="w-full border border-gray-200 rounded-lg px-4 py-2.5 text-sm text-gray-700 focus:outline-none focus:border-teal-400"
                    />
                  </div>
                </div>
                <div>
                  <label className="text-xs font-bold text-gray-500 uppercase tracking-wide mb-1 block">
                    Correo Electrónico *
                  </label>
                  <input
                    name="email"
                    required
                    type="email"
                    placeholder="tu@correo.com"
                    className="w-full border border-gray-200 rounded-lg px-4 py-2.5 text-sm text-gray-700 focus:outline-none focus:border-teal-400"
                  />
                </div>
                <div>
                  <label className="text-xs font-bold text-gray-500 uppercase tracking-wide mb-1 block">
                    Teléfono
                  </label>
                  <input
                    name="telefono"
                    type="tel"
                    placeholder="+1 809-000-0000"
                    className="w-full border border-gray-200 rounded-lg px-4 py-2.5 text-sm text-gray-700 focus:outline-none focus:border-teal-400"
                  />
                </div>
                <div>
                  <label className="text-xs font-bold text-gray-500 uppercase tracking-wide mb-1 block">
                    Servicio de interés
                  </label>
                  <select
                    name="servicio"
                    className="w-full border border-gray-200 rounded-lg px-4 py-2.5 text-sm text-gray-700 focus:outline-none focus:border-teal-400"
                  >
                    <option value="">Selecciona un servicio</option>
                    <option>Diseño y Construcción de Piscinas</option>
                    <option>Fabricación e Instalación de Hidromasajes</option>
                    <option>Mantenimiento de Piscinas</option>
                    <option>Verjas Perimetrales</option>
                    <option>Covers</option>
                    <option>Igualas</option>
                  </select>
                </div>
                <div>
                  <label className="text-xs font-bold text-gray-500 uppercase tracking-wide mb-1 block">
                    Mensaje
                  </label>
                  <textarea
                    name="mensaje"
                    rows={4}
                    maxLength={500}
                    placeholder="Cuéntanos sobre tu proyecto..."
                    className="w-full border border-gray-200 rounded-lg px-4 py-2.5 text-sm text-gray-700 focus:outline-none focus:border-teal-400 resize-none"
                  />
                </div>
                <button
                  type="submit"
                  disabled={loading}
                  className="w-full bg-teal-600 hover:bg-teal-500 text-white font-bold py-3 rounded-lg text-sm tracking-wide transition-colors cursor-pointer whitespace-nowrap disabled:opacity-60"
                >
                  {loading ? "Enviando..." : "ENVIAR SOLICITUD"}
                </button>
              </form>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
